import { useEffect } from "react";

// React 19 hoists Helmet/SeoHead tags into <head> without replacing pre-existing ones. Build-time snapshots
// bake page tags marked data-shell; this detaches each shell tag once React renders its own twin (and
// reattaches it on pages that render none). A JS-only fallback <title> keeps browser tabs labelled on
// pages without a SeoHead — Google never sees it on pages that set their own.
const selectorFor = (el) => {
  if (el.tagName === "TITLE") return "title";
  if (el.tagName === "LINK") return `link[rel="${el.getAttribute("rel")}"]`;
  if (el.hasAttribute("property")) return `meta[property="${el.getAttribute("property")}"]`;
  return `meta[name="${el.getAttribute("name")}"]`;
};

export function useShellSeoCleanup() {
  useEffect(() => {
    const shells = Array.from(document.head.querySelectorAll("[data-shell]"));
    if (!shells.some((el) => el.tagName === "TITLE")) {
      const t = document.createElement("title");
      t.setAttribute("data-shell", "");
      t.textContent = "Hello Mortgage";
      shells.push(t);
    }
    const sweep = () => {
      shells.forEach((el) => {
        const twin = document.head.querySelector(`${selectorFor(el)}:not([data-shell])`);
        if (twin && el.isConnected) el.remove();
        else if (!twin && !el.isConnected) document.head.appendChild(el);
      });
    };
    sweep();
    const mo = new MutationObserver(sweep);
    mo.observe(document.head, { childList: true });
    return () => mo.disconnect();
  }, []);
}
